import { useEffect } from 'react'

interface ToastProps {
  message: string
  visible: boolean
  onDismiss: () => void
  duration?: number
}

export function Toast({ message, visible, onDismiss, duration = 1500 }: ToastProps) {
  useEffect(() => {
    if (!visible) return
    const t = setTimeout(onDismiss, duration)
    return () => clearTimeout(t)
  }, [visible, duration, onDismiss])

  if (!visible) return null
  return (
    <div className="toast animate-pop" role="status" aria-live="polite">
      {message}
    </div>
  )
}
